<template>
  <div>
    <!-- search input -->
    <section>
      <b-card
        no-body
        class="knowledge-base-bg text-center"
        :style="{backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`}"
      >
        <b-card-body class="card-body">
          <h2 class="text-primary">
            {{ $t('objects.real_estate_searching') }}
          </h2>
          <b-card-text class="mb-2">
            {{ $t('objects.search_by_name') }}
          </b-card-text>
          <b-row>
            <b-col
              md="6"
              offset="3"
            >
              <b-form-group>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filter_form_query.search"
                    :placeholder="$t('generals.search')"
                    type="text"
                    class=""
                    @input="searchObjects"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="3"
              class="justify-content-between"
            >
              <b-button
                v-if="GET_USER_PERMISSIONS.includes('content_management')"
                v-b-modal.add-object
                variant="primary"
                class="mx-auto"
                pill
              >
                <feather-icon
                  icon="PlusIcon"
                />
                {{ $t('objects.add_object') }}
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </section>
    <!--/ search input -->
    <div>
      <b-row class="align-items-stretch">
        <b-col
          v-for="(object, index) in GET_OBJECTS"
          :key="index"
          md="3"
        >
          <object-card
            :object_info="object"
            @click="$router.push({name: 'object-view', params: { id: object.id }})"
          />
        </b-col>
      </b-row>
    </div>
    <add-object-modal @saveSuccess="refresh" />
    <b-modal
      v-model="client_modal"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      cancel-disabled
      ok-only
      :ok-title="$t('generals.save')"
      :title="$t('objects.add_or_search_client')"
      size="lg"
      centered
      @ok="saveClick"
    >
      <validation-observer ref="client_form">
        <b-row>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('objects.client')"
              rules="required"
            >
              <label for="autosuggest__input">{{ $t('objects.client') }}</label>
              <vue-autosuggest
                :suggestions="suggestOptions"
                :input-props="{id:'autosuggest__input', class: 'form-control', placeholder: $t('generals.search')}"
                :limit="10"
                :get-suggestion-value="option => option.item.title"
                @selected="onSelected"
                @input="searchClients"
              >
                <template slot-scope="{suggestion}">
                  <div class="d-flex align-items-center">
                    <div class="detail ml-50">
                      <b-card-text class="mb-0">
                        {{ suggestion.item.title }}
                      </b-card-text>
                    </div>
                  </div>
                </template>
              </vue-autosuggest>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              name="Тел"
              rules="required"
            >
              <b-form-group>
                <label for="phone__number">{{ $t('phone_number') }}</label>
                <b-form-input v-model="client.phones[0]" />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BFormInput, BFormGroup, BInputGroupPrepend, BInputGroup, BCardText, BCardBody,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { VueAutosuggest } from 'vue-autosuggest'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import objectCard from '@/components/objectCard.vue'
import addObjectModal from './components/modals/addObject.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    objectCard,
    FeatherIcon,
    BButton,
    BFormInput,
    BCardText,
    BCardBody,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    addObjectModal,
    VueAutosuggest,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      def_obj: {
        currency: 1,
        region: null,
        rayon: null,
        title: '',
        brand: '',
        site: '',
        object_type: null,
      },
      // selected: null,
      object_info: {
        id: 1,
        title: 'Solaris',
        created_at: '2021-06-08',
        apartments_count: 5,
        flats_count: 340,
        // photo: 'https://picsum.photos/1024/840/?image=41',
      },
      filter_form_query: {
        search: null,
      },
      timeout: 600,
      client_modal: false,
      client: {
        phones: [],
      },
      client_selected: false,
    }
  },
  computed: {
    ...mapGetters('objects', ['GET_OBJECTS']),
    ...mapGetters('clients', ['getClientsList']),
    ...mapGetters('users', ['GET_USER_PERMISSIONS']),
    getLocale() {
      const locale = this.$i18n.locale || 'uz'
      return locale
    },
    suggestOptions() {
      if (this.getClientsList.results.length && !this.client_selected) {
        return [{ data: this.getClientsList.results }]
      }
      return []
    },
  },
  created() {
    this.refresh()
  },
  methods: {
    ...mapActions('objects', ['FETCH_OBJECTS', 'ADD_OBJECT']),
    ...mapActions('clients', ['FETCH_CLIENTS_LIST', 'ADD_NEW_CLIENT']),
    refresh() {
      this.FETCH_OBJECTS(this.filter_form_query)
    },
    onSelected(option) {
      console.log(option)
      this.client_selected = true
      this.selected = option.item.title
      // const [phone] = option.item.phones
      this.$nextTick(() => {
        this.client = option.item
      })
      console.log(this.client.phone_number)
    },
    searchObjects() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.refresh()
      }, 600)
    },
    saveClick() {
      console.log('save')
      if (this.client_selected) {
        console.log(this.client)
      } else {
        console.log('new client', this.client)
        this.client.entity = 'fizichiskiy'
        this.ADD_NEW_CLIENT(this.client).then(resp => {
          this.$_successToast('Создан новый клиент')
          sessionStorage.setItem('selected_client', JSON.stringify(resp.data))
        })
      }
    },
    searchClients(text) {
      this.client_selected = false
      this.client.title = text
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.FETCH_CLIENTS_LIST({ search: text })
      }, 600)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
